import Button from "devextreme-react/button";
import { confirm } from "devextreme/ui/dialog";
import { useContext } from "react";
import { LoadPagePanel } from "../../../../components";
import { AR, OrderStatus } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useCancelConfirmation } from "../api/cancel-confirmation";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function CancelConfirmationButton() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const cancelConfirmation = useCancelConfirmation(order.details.retailOrderID,
		() => {
			showSuccessMessage('Confirmation has been cancelled');
			refetchOrder();
		},
		(error) => showErrorMessage(error));

	const changeRequestExists = order.details.changeOrderProducts?.filter(x => x.roProductChangeRequestID > 0).length > 0

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-cancel-confirmation' }}
				text="Cancel Confirmation"
				icon="Inscyth-Cancel"
				visible={order.details.resolvedARs.includes(AR.CfiToConfirmOrChangeOrder)
					&& !changeRequestExists
					&& !order.details.resolvedARs.includes(AR.CfiToUploadCocInvoice)
					&& !order.details.resolvedARs.includes(AR.InstallerToUploadVerificationForm)
					&& !order.details.resolvedARs.includes(AR.CfiToEnterActualInstallDate)
					&& order.details.orderStatusID === OrderStatus.Open
					&& !order.details.IME}
				disabled={cancelConfirmation.isLoading}
				onClick={() => {
					confirm("Please check to make sure that an install date has not been entered and an invoice has not been submitted.<br/>Are you sure you want to cancel the confirmation?",
						"Cancel Confirmation")
						.then(result => {
							if (result) {
								cancelConfirmation.mutate();
							}
						});
				}} >
			</Button>
			<LoadPagePanel visible={cancelConfirmation.isLoading}></LoadPagePanel>
		</>
	)
}
